import { render, staticRenderFns } from "./Productstable1.vue?vue&type=template&id=156aa8e2&scoped=true&"
import script from "./Productstable1.vue?vue&type=script&lang=js&"
export * from "./Productstable1.vue?vue&type=script&lang=js&"
import style0 from "./Productstable1.vue?vue&type=style&index=0&id=156aa8e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156aa8e2",
  null
  
)

export default component.exports